import { createFileRoute } from '@tanstack/react-router'

import { AccountPage } from '@/features/account/components/account-page'

export const Route = createFileRoute('/_app/account/profile')({
  component: AccountPage,
})
